import { fetchUtils } from 'react-admin';
import * as Sentry from '@sentry/react';

export const httpClient = (url, options = {}) => {
  const innerOptions = options;
  if (!options.headers) {
    innerOptions.headers = new Headers({ Accept: 'application/json' });
  }
  const token = localStorage.getItem('token');
  innerOptions.headers.set('Authorization', `Bearer ${token}`);
  return fetchUtils.fetchJson(url, innerOptions).catch((error) => {
    Sentry.captureException(error);
    return error;
  });
};
